import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import logolight from "../../assets/images/cluedinimage/app_logo.png";
import logodark from "../../assets/images/cluedinimage/app_logo.png";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import {
  Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label,
  InputGroup, InputGroupText
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";



// actions
import { loginUser } from "../../store/actions";


import { createSelector } from 'reselect';

const Login = props => {
  document.title = "Login | Clued.in Closet - Web Admin ";
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  }
  const dispatch = useDispatch();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "" || '',
      password: "" || '',
    },
    validationSchema: Yup.object({
      // email: Yup.string().required("Please Enter Your User name"),
      // password: Yup.string().required("Please Enter Your Password"),
      email: Yup.string()
        .matches(
          /^[A-Za-z\s]+$/,  // Regex to allow only letters and spaces
          "Invalid Username"
        )
        .required("Please Enter Your Username"),
      password: Yup.string()
        .matches(
          /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&^#()_+^\.])[A-Za-z\d@$!%*?&^#()_+^\.]{8,}$/,
          "Invalid Password"
        )
        .required("Please Enter Your Password"),

    }),
    onSubmit: (values) => {
      dispatch(loginUser(values, props.router.navigate));
    }
  });

  const loginpage = createSelector(
    (state) => state.login,
    (state) => ({
      error: state.error,
    })
  );
  // Inside your component
  const { error } = useSelector(loginpage);





  useEffect(() => {
    document.body.className = "bg-pattern";
    // remove classname when component will unmount
    return function cleanup() {
      document.body.className = "";
    };
  });


  return (
    <React.Fragment>

      <div className="bg-overlay"></div>
      <div className="account-pages vh-100" >
        <Container className="h-100">
          <div className="justify-content-center align-item-center d-flex h-100">
            <div class="logindiv col-md-8 col-lg-6 col-xl-4" >
              <Card>
                <CardBody className="p-4">
                  <div>
                    <div className="text-center">
                      <Link to="/">
                        <img
                          src={logodark}
                          alt=""
                          // height="50"
                          className="auth-logo logo-dark mx-auto"
                        />
                        <img
                          src={logolight}
                          alt=""
                          // height="50"
                          className="auth-logo logo-light mx-auto"
                        />
                      </Link>
                    </div>
                    <h4 className="font-size-18 text-muted mt-2 mb-0 text-center">
                      Welcome Back Admin!
                    </h4>
                    <p className="mb-5 mt-1 text-center">
                      Sign in to continue.
                    </p>
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      {error ? <Alert color="danger"><div>{error}</div></Alert> : null}
                      <Row>
                        <Col md={12}>
                          <div className="mb-4">
                            <Label className="form-label">Username</Label><span style={{ color: "red" }}>*</span>
                            <Input
                              name="email"
                              className="form-control"
                              placeholder="Enter Username"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.email || ""}
                              invalid={
                                validation.touched.email && validation.errors.email ? true : false
                              }
                              onKeyDown={(e) => {
                                if (e.key === " ") {
                                  e.preventDefault(); // block space key
                                }
                              }}
                              onPaste={(e) => {
                                const pastedText = e.clipboardData.getData('text');
                                if (pastedText.includes(" ")) {
                                  e.preventDefault(); // block pasting if there's a space
                                }
                              }}
                            />
                            {validation.touched.email && validation.errors.email ? (
                              <FormFeedback type="invalid"><div>{validation.errors.email}</div></FormFeedback>
                            ) : null}
                          </div>
                          <div className="mb-4">
                            <Label className="form-label">Password</Label><span style={{ color: "red" }}>*</span>
                            <InputGroup>
                              <Input
                                name="password"
                                value={validation.values.password || ""}
                                type={showPassword ? "text" : "password"}
                                placeholder="Enter Password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={
                                  validation.touched.password && validation.errors.password
                                    ? true
                                    : false
                                }
                                onKeyDown={(e) => {
                                  if (e.key === " ") {
                                    e.preventDefault(); // block space key
                                  }
                                }}
                                onPaste={(e) => {
                                  const pastedText = e.clipboardData.getData('text');
                                  if (pastedText.includes(" ")) {
                                    e.preventDefault(); // block pasting if there's a space
                                  }
                                }}
                              />
                              <InputGroupText onClick={togglePasswordVisibility} style={{ cursor: "pointer" }}>
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                              </InputGroupText>
                              {validation.touched.password && validation.errors.password ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.password}
                                </FormFeedback>
                              ) : null}
                            </InputGroup>
                          </div>


                          <div className="d-grid mt-4">
                            <button
                              className="btn"
                              type="submit"
                              style={{
                                backgroundColor: "#020203",
                                color: "white"
                              }}
                            >
                              Log In
                            </button>
                          </div>


                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              {/* <div className="mt-5 text-center">

                <p className="text-white-50">
                  © {new Date().getFullYear()} Clued.in Closet.

                </p>
              </div> */}
            </div>
          </div>
        </Container>
        {/* <div className="mt-auto text-center" style={{ paddingBottom: "20px" }}>
          <p className="whitediv">
            © {new Date().getFullYear()} Clued.in Closet.
          </p>
        </div> */}
        <div
          className="text-center"
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            padding: "10px",
            // backgroundColor: "#020203",
            color: "white",
          }}
        >
          <p className="text-white-50">
            © {new Date().getFullYear()} Clued.in Closet.
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
